import { render, staticRenderFns } from "./comeInShop.vue?vue&type=template&id=3b21f1a1&scoped=true"
import script from "./comeInShop.vue?vue&type=script&lang=js"
export * from "./comeInShop.vue?vue&type=script&lang=js"
import style0 from "./comeInShop.vue?vue&type=style&index=0&id=3b21f1a1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b21f1a1",
  null
  
)

export default component.exports